// extracted by mini-css-extract-plugin
module.exports = {"profile__personal-data":"_3c1NpjnF","profile__personalData":"_3c1NpjnF","card-section":"_1ktu4QdC","cardSection":"_1ktu4QdC","delete":"_1YRGnPSW","card":"_1JgvAtfv"};